import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { productHomeRoute } from '@app/constants/app-routing.constants';

import { BusHomeContainer } from '@buses/bus-home/bus-home.container';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';

export const busesRootRoute = 'buses';
export const calendarRoute = 'calendar';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: productHomeRoute,
        component: BusHomeContainer,
        children: [{
          path: calendarRoute,
          outlet: 'search',
          component: SearchBarMobileCalendarContainer,
        }]
      },
      {
        path: `${productHomeRoute}/:bus_type/:departure/:arrival/:departure_date/:arrival_date/:adults/:company`,
        component: BusHomeContainer,
        children: [{
          path: calendarRoute,
          outlet: 'search',
          component: SearchBarMobileCalendarContainer,
        }]
      },
      {
        path: `${productHomeRoute}/:bus_type/:departure/:arrival/:departure_date/:adults/:company`,
        component: BusHomeContainer,
        children: [{
          path: calendarRoute,
          outlet: 'search',
          component: SearchBarMobileCalendarContainer,
        }]
      }
    ])],
  exports: [
    RouterModule
  ]
})
export class BusHomeRoutingModule { }
